'use client'

import * as Sentry from '@sentry/nextjs'
import { useEffect } from 'react'

export default function GlobalError({
  error,
}: {
  error: Error & { digest?: string }
}) {
  useEffect(() => {
    Sentry.captureException(error)
  }, [error])

  return (
    <html>
      <body>
        <h1>Algo deu errado!</h1>
        <p>Ocorreu um erro inesperado. Por favor, tente novamente.</p>
      </body>
    </html>
  )
}
